<template>
  <div>
    <AppDialog
      class="time-off-policies-wizard"
      title="Edit assigned members"
      :show="showDialog || loadingPolicy"
      :loading="loadingPolicy"
      append-to-body
      position="centered"
      @close="closeDialogs"
    >
      <ValidationObserver ref="dialogObserver">
        <ValidationObserver ref="TimeOffPolicyMembersSetupFormObserver">
          <TimeOffPolicyMembersSetupForm
            v-if="showDialog"
            :time-off-policy="timeOffPolicy"
            :organization-id="organizationId"
            :members-data="membersData"
            :show-dialog="showDialog"
            :countries="countries"
            @policy-updated="policyUpdated"
          />
        </ValidationObserver>
      </ValidationObserver>
      <template slot="footer">
        <AppButton
          class="cancel"
          @click="closeDialogs"
        >
          Cancel
        </AppButton>
        <AppButton
          type="primary"
          :disabled="saving"
          @click="save"
        >
          Save
        </AppButton>
      </template>
    </AppDialog>
  </div>
</template>

<script>
import TimeOffPolicyMixin from '~/mixins/time_off_policies/TimeOffPolicyMixin';
import TimeOffPolicyMembersSetupForm from '~/components/time_off_policies/TimeOffPolicyMembersSetupForm.vue';

export default {
  name: 'TimeOffPolicyMembersEdit',
  components: {
    TimeOffPolicyMembersSetupForm,
  },
  mixins: [TimeOffPolicyMixin],
};
</script>
